var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { staticClass: "mb-12" }, [
    _c(
      "ul",
      { staticClass: "flex items-center -mr-20" },
      [
        _vm._l(_vm.steps, function (step, index) {
          return [
            index < _vm.currentStep
              ? _c("li", { staticClass: "relative pr-8 sm:pr-20" }, [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "relative w-8 h-8 flex items-center justify-center bg-primary-600 rounded-full transition ease-in-out duration-150",
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "w-5 h-5 text-white",
                          attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                              "clip-rule": "evenodd",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "absolute -left-10 top-10 w-full text-center text-sm",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(step.name) +
                          "\n                "
                      ),
                    ]
                  ),
                ])
              : index === _vm.currentStep
              ? _c("li", { staticClass: "relative pr-8 sm:pr-20" }, [
                  index < _vm.steps.length
                    ? _c(
                        "div",
                        { staticClass: "absolute inset-0 flex items-center" },
                        [_c("div", { staticClass: "h-0.5 w-full bg-gray-200" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(1, true),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "absolute -left-10 top-10 w-full text-center text-sm",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(step.name) +
                          "\n                "
                      ),
                    ]
                  ),
                ])
              : _c("li", { staticClass: "relative pr-8 sm:pr-20" }, [
                  index < _vm.steps.length - 1
                    ? _c(
                        "div",
                        { staticClass: "absolute inset-0 flex items-center" },
                        [_c("div", { staticClass: "h-0.5 w-full bg-gray-200" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", {
                    staticClass:
                      "relative w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full transition ease-in-out duration-150",
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "absolute -left-10 top-10 w-full text-center text-sm text-gray-400",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(step.name) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "absolute inset-0 flex items-center" }, [
      _c("div", { staticClass: "h-0.5 w-full bg-primary-600" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "relative w-8 h-8 flex items-center justify-center bg-white border-2 border-primary-600 rounded-full",
      },
      [_c("span", { staticClass: "h-2.5 w-2.5 bg-primary-600 rounded-full" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }